const CHANGE_STORE_DATA_ANALYSE_TIME_RANGE = "CHANGE_STORE_DATA_ANALYSE_TIME_RANGE";

const dataAnalyseTimeRangeAction = (name, value) => {
  return {
    type: CHANGE_STORE_DATA_ANALYSE_TIME_RANGE,
    payload: { name, value },
  };
};

const handleChangeDataAnalyseTimeRange = (name, value) => {
  return (dispatch) => {
    dispatch(dataAnalyseTimeRangeAction(name, value));
  };
};

export { handleChangeDataAnalyseTimeRange, CHANGE_STORE_DATA_ANALYSE_TIME_RANGE };
